import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, InstagramIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-cream" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-51">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-52">
            <h2 className="font-display text-5xl md:text-6xl text-near-black mb-8" data-id="element-53">
              Find Us
            </h2>
            <div className="space-y-8" data-id="element-54">
              {[{
              icon: <MapPinIcon className="w-5 h-5 text-brand-gold" data-id="element-55" />,
              title: 'Location',
              content: '7375 Executive Place, Suite 214, Lanham MD'
            }, {
              icon: <PhoneIcon className="w-5 h-5 text-brand-gold" data-id="element-56" />,
              title: 'Phone',
              content: '(240) 921-7857',
              href: 'tel:2409217857'
            }, {
              icon: <InstagramIcon className="w-5 h-5 text-brand-gold" data-id="element-57" />,
              title: 'Instagram',
              content: '@roziiepse',
              href: 'https://www.instagram.com/roziiepse/'
            }].map(item => <div key={item.title} className="flex items-start gap-4" data-id="element-58">
                  <div className="w-12 h-12 bg-warm-brown rounded-full flex items-center justify-center shrink-0" data-id="element-59">
                    {item.icon}
                  </div>
                  <div data-id="element-60">
                    <h3 className="font-display text-2xl text-near-black mb-1" data-id="element-61">
                      {item.title}
                    </h3>
                    {item.href ? <a href={item.href} className="font-body text-near-black/70 hover:text-burnt-sienna transition-colors" data-id="element-62">
                        {item.content}
                      </a> : <p className="font-body text-near-black/70" data-id="element-63">
                        {item.content}
                      </p>}
                  </div>
                </div>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-warm-brown p-2 md:p-4 rounded-2xl shadow-2xl h-[400px] md:h-[500px]" data-id="element-64">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3103.743058814561!2d-76.8656126!3d38.9526719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7c0f1b2b3b4b5%3A0x1b2b3b4b5b6b7b8b!2s7375%20Executive%20Pl%20%23214%2C%20Lanham%2C%20MD%2020706!5e0!3m2!1sen!2sus!4v1709999999999!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0,
            borderRadius: '1rem'
          }} allowFullScreen loading="lazy" title="Location Map" data-id="element-65"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}